import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
/**
 * Плагин для копирования в буфер обмена
 * https://github.com/Inndy/vue-clipboard2
 */
